module.exports = __webpack_public_path__ + "img/bank.e26cb810.png";